import type { PSLListResponse } from './api';

export const normalizePSLList = (list: PSLListResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.displayValue,
    value: row.lookupCodeId,
  }));
};
